import request from '@/utils/http';
import { SRM, SRM_FILE } from '../constant/constant.js';

// const SRM = '/v50';
// const SRM_FILE = '/v50';


// 司机信息
export const getDriverInfo = (applyCode) => {
    return request({
        url: `${SRM}/supplierDriverJoinApplyRecord/driver/${applyCode}`,
        method: 'get',
        // data: params
    });
};

// 获取司机加入供应商列表
export const getRecordList = data => {
    return request({
        url: `${SRM}/supplierDriverJoinApplyRecordPage`,
        method: 'post',
        data
    });
};

// 车辆信息
export const getVehicleInfo = (applyCode) => {
    return request({
        url: `${SRM}/supplierDriverJoinApplyRecord/car/${applyCode}`,
        method: 'get',
    });
};

// 申请通过校验
export const checkPass = data => {
    return request({
        url: `${SRM}/supplierDriverJoinApplyRecord/checkPass`,
        method: 'post',
        data
    });
};

// 申请记录-通过
export const passApplyRecord = data => {
    return request({
        url: `${SRM}/supplierDriverJoinApplyRecord/pass`,
        method: 'post',
        data
    });
};

// 申请记录-驳回
export const rejectApplyRecord = data => {
    return request({
        url: `${SRM}/supplierDriverJoinApplyRecord/reject`,
        method: 'post',
        data
    });
};
